import React from "react";
import styling from "./Loader.module.css";

export default function Loader() {
  return (
    <div className={styling.LoaderSection}>
      <div className={styling.Loader}>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
        <div className={styling.object}></div>
      </div>
    </div>
  );
}
